import { RECT3D_NUMBER_TYPE } from "@visactor/vrender-core";

import { Base3dPicker } from "../common/base-3d-picker";

export class DefaultCanvasRect3dPicker extends Base3dPicker {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer, this.type = "rect3d", this.numberType = RECT3D_NUMBER_TYPE, 
        this.themeType = "rect";
    }
}
//# sourceMappingURL=rect3d-picker.js.map
